import { useEffect, useRef } from 'react';
import { useT } from '../i18n';
import { Assurance } from './Assurance';
import './Acknowledgement.css';

/**
 * The end of the flow. Deliberately contains no number, estimate or range —
 * there is no automated valuation, and implying one here would be a promise the
 * product cannot keep. The reference number is not shown: the owner receives it
 * (and the analysis) by email.
 */
export function Acknowledgement() {
  const t = useT();
  const headingRef = useRef<HTMLHeadingElement | null>(null);

  // The page changed underneath the owner without a navigation; move focus so a
  // screen reader lands on the outcome instead of staying on a vanished button.
  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <section className="ack" aria-labelledby="ack-heading">
      {/* The opening statement — eyebrow, headline, paragraph and signature — is
          one centred block, spaced tightly within itself. The sections below are
          separated from it by the container's much larger gap, so the page
          breathes between blocks the way the landing page does. */}
      <div className="ack__hero">
        <p className="eyebrow">{t.success.eyebrow}</p>

        {/* The confirmation is the heading; what happens next is the paragraph
            under it. Splitting them lets the fact land on its own line at
            display size instead of being buried mid-sentence. */}
        <h1 id="ack-heading" ref={headingRef} tabIndex={-1}>
          {t.success.headline}
        </h1>

        <p className="lede ack__body">{t.success.body}</p>

        <p className="ack__signature">{t.success.signature}</p>
      </div>

      {/*
        What arrives by email, closing the page. The heading sits OUTSIDE the
        panel — it titles the block rather than labelling a row inside it.
      */}
      <section className="ack__deliverable" aria-labelledby="ack-deliverable-heading">
        <h2 className="ack__deliverable-heading" id="ack-deliverable-heading">
          {t.success.deliverableHeading}
        </h2>
        <ul className="ack__deliverable-list">
          {t.success.deliverableItems.map((item) => (
            <li className="ack__deliverable-item" key={item}>
              {item}
            </li>
          ))}
        </ul>
      </section>

      {/* Aceleași întrebări frecvente ca pe formular, sub „Ce primiți". */}
      <Assurance />
    </section>
  );
}
